import React from "react";
import { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../css/policiesslider.css";
import { FaArrowLeft, FaArrowRight, FaArrowCircleRight, FaYoutube } from "react-icons/fa";
import { Link } from "react-router-dom";
import axios from 'axios';
import { Helmet } from 'react-helmet-async';

const PoliciesSlider = ({ category }) => {
  const [Products, setallProducts] = useState([]);
  const API_URL = process.env.REACT_APP_Dashboard_API_URL;
  let sliderRef = React.useRef(null);
  const [modalVideo, setModalVideo] = useState(null);
  const [getProductsError, setGetProductsError] = useState();

  useEffect(() => {
    getAllVideo();
  }, []);

  const sliderSettings = {
    dots: false,
    infinite: Products.length > 2,
    speed: 500,
    slidesToShow: Math.min(Products.length, 1),
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: Math.min(Products.length, 1)
        }
      }
    ]
  };

  const getAllVideo = async () => {
    if (category) {
      try {
        const response = await axios.get(`${API_URL}AllPolicies`);
        if (response.status == 200) {
          const transformedProducts = response.data
            .filter(product => product.productCategory === category);
          if (transformedProducts.length === 0) {
            setGetProductsError("Policies Video Not Found");
          }
          setallProducts(transformedProducts);
        }
        else {
          setGetProductsError("Products Not Found");
        }
      } catch (error) {
        setGetProductsError("Products Not Found");
      }
    }
    else {
      try {
        const response = await axios.get(API_URL + "AllPolicies");
        if (response.status === 200) {
          const transformedPolicies = response.data
            .filter(policy => policy.productCategory !== "General Awareness");
          if (transformedPolicies.length === 0) {
            setGetProductsError("Policies Video Not Found");
          }
          setallProducts(transformedPolicies);
        } else {
          setGetProductsError("Policies Video Not Found");
        }
      } catch (error) {
        setGetProductsError("Policies Video Not Found");
      }
    }
  };

  const extractYouTubeId = (url) => {
    if (typeof url !== 'string' || !url.trim()) return '';
    const match = url.match(/(?:\?v=|\/embed\/|\.be\/|\/shorts\/)([^&\n?#]+)/);
    return match ? match[1] : null;
  };

  const openVideoModal = (videoUrl) => {
    const videoId = extractYouTubeId(videoUrl);
    setModalVideo(`https://www.youtube.com/embed/${videoId}`);
  };

  const closeModal = () => {
    setModalVideo(null);
  };

  return (
    <div className="policies-slider-container">
      <Helmet>
        <title>Compare Insurance Policies India | Best Insurance Plans & Reviews</title>
        <meta
          name="description"
          content="Compare insurance policies in India with Policy Samjho. Explore best insurance plans, watch expert policy reviews, and get clarity on coverages to secure your future."
        />
        <meta
          name="keywords"
          content="compare insurance policies, best insurance policies India, insurance policy review, insurance guidance, understand insurance policy, policy consultation India"
        />
        <link rel="canonical" href="https://policysamjho.com/policies" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            "name": "Insurance Policy Comparison & Reviews",
            "description": "Explore and compare various insurance policies through expert videos and detailed policy reviews from Policy Samjho.",
            "provider": {
              "@type": "Organization",
              "name": "Policy Samjho",
              "url": "https://policysamjho.com"
            },
            "serviceType": "Insurance Policy Guidance & Videos",
            "areaServed": "IN",
            "url": "https://policysamjho.com/policies",
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "18005703990",
              "email": "info@policysamjho.com",
              "contactType": "customer service"
            }
          })}
        </script>
      </Helmet>
      
      <h1 className="slider-heading" style={{ color: '#fff' }}>
        Compare & Explore <span style={{ color: '#F5A526' }}>Insurance Policies</span>
      </h1>
      
      <p className="slider-description">
        Review best insurance policies in India through expert-led videos and simplified explanations.
      </p>

      {getProductsError && (
        <div style={{ color: "red", fontSize: "14px", marginTop: "5px" }}>{getProductsError}</div>
      )}
      {Products.length > 1 && (
        <div className="slider-controls">
          <button className="custom-arrow prev" onClick={() => sliderRef.slickPrev()}><FaArrowLeft /></button>
          <button className="custom-arrow next" onClick={() => sliderRef.slickNext()}><FaArrowRight /></button>
        </div>
      )}

      <div className="slider-wrapper">
        <Slider ref={(slider) => (sliderRef = slider)} {...sliderSettings}>
          {Products.map((policy, index) => {
            const videoId = extractYouTubeId(policy.video);
            const thumbnail = `https://img.youtube.com/vi/${videoId}/0.jpg`;
            return (
              <div key={index} className="policy-slide-item">
                <div className="video-thumbnail-container" onClick={() => openVideoModal(policy.video)}>
                  <FaYoutube className="youtube-icon" />
                  <img
                    className="policy-video-thumbnail"
                    src={thumbnail}
                    alt={policy.productName || "Insurance Policy Review"}
                    style={{ cursor: 'pointer' }}
                  />
                </div>
                <div className="policy-details">
                  <div className="policy-title-row">
                    <h3 data-title={policy.productCategory}>{policy.productCategory}</h3>
                    <Link
                      to={policy.link || '#'}
                      className="arrow-link"
                      onClick={(e) => {
                        e.stopPropagation();
                        window.scrollTo(0, 0);
                      }}
                    >
                      <FaArrowCircleRight />
                    </Link>
                  </div>
                  <p data-description={policy.description}><b>Policy Explanation : </b>{policy.description}</p>
                  <p data-description={policy.policiesType}><b>Plan Type : </b>{policy.productType}</p>
                  <p data-description={policy.productName}><b>Product Name : </b> {policy.productName}</p>
                  <p data-description={policy.companyName}><b>Company Name : </b>{policy.companyName}</p>
                </div>

                <div>
                  {policy.productDocument && (
                    <a
                      href={`${API_URL}Document/${policy.productDocument.split("\\").pop()}`}
                      target="_blank"
                      download
                      rel="noopener noreferrer"
                      className="text-blue-400"
                    >
                      Download Policy Review PDF
                    </a>
                  )}
                </div>
              </div>
            );
          })}
        </Slider>
      </div>
      {modalVideo && (
        <div className="video-modal-overlay" onClick={closeModal}>
          <div className="video-modal-content" onClick={e => e.stopPropagation()}>
            <iframe
              src={`${modalVideo}?autoplay=1`}
              title="Insurance Policy Explanation Video"
              allow="autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              frameBorder="0"
            />
            <button className="modal-close-btn" onClick={closeModal}>✖</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default PoliciesSlider;